import React, { useEffect, useState } from "react"
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date"
import {
	Box,
	Grid,
	Popover,
	Button,
	CircularProgress
} from "@material-ui/core"
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers"
import DateFnsUtils from "@date-io/date-fns"
import { ptBR } from "date-fns/locale"

import useStyles from "@/pages/Admin/MeetingAnalyzer/Detail/DateEditPopover/styles"

type DateEditPopoverProps = {
	value: Date | null
	anchorElement: HTMLElement | null
	onClose: () => void
	onConfirm: (selectedDate: Date | null) => Promise<void>
}

const DateEditPopover: React.FC<DateEditPopoverProps> = (props) => {
	const {
		value,
		anchorElement,
		onClose,
		onConfirm
	} = props

	const [selectedDate, setSelectedDate] = useState<Date | null>(value ?? null)
	const [isSaving, setIsSaving] = useState(false)
	const classes = useStyles()

	const isOpened = Boolean(anchorElement)

	const handleChange = (date: MaterialUiPickersDate) => {
		setSelectedDate(date as Date | null)
	}

	const handleSave = async () => {
		setIsSaving(true)
		await onConfirm(selectedDate)
		setIsSaving(false)
	}

	const handleCancel = () => {
		onClose()
	}

	const handleClose = () => {
		onClose()
	}

	useEffect(() => {
		if (value) {
			setSelectedDate(value ?? null)
		}
	}, [isOpened])

	return (
		<Popover
			open={isOpened}
			anchorEl={anchorElement}
			onClose={handleClose}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "left"
			}}
		>
			<Box className={classes.popperContainer}>
				<Grid container direction="column" spacing={2}>
					<Grid item>
						<MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
							<Grid container direction="column">
								<Grid item>
									<KeyboardDatePicker
										variant="static"
										value={selectedDate}
										onChange={handleChange}
									/>
								</Grid>
							</Grid>
						</MuiPickersUtilsProvider>
					</Grid>
					<Grid item>
						<Grid container justifyContent="flex-end">
							<Grid item>
								<Grid container spacing={1}>
									<Grid item>
										<Button
											color="primary"
											onClick={handleCancel}
											disabled={isSaving}
										>
											Cancelar
										</Button>
									</Grid>
									<Grid item>
										<Button
											color="primary"
											onClick={handleSave}
											disabled={isSaving}
											endIcon={isSaving && <CircularProgress size={20} />}
										>
											Salvar
										</Button>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Box>
		</Popover>
	)
}

export default DateEditPopover
